<template>
  <div
    class="flex justify-between gap-2 py-4 md:py-3 px-5 md:px-6 bg-primary border-t border-secondary"
  >
    <Button
      v-if="maxSmall"
      variant="secondary"
      type="gray"
      icon
      size="xl"
      @click="mediaInput.click()"
    >
      <Icon name="attachment" />
    </Button>

    <Button
      v-else
      variant="link"
      type="gray"
      size="md"
      @click="mediaInput.click()"
    >
      <template #start>
        <Icon name="attachment" />
      </template>
      {{ $t("components.buttons.add_media") }}
    </Button>

    <FileInput
      accept="image/png, image/jpg, image/jpeg, video/mp4, video/quicktime, video/ogg, video/webm"
      ref="mediaInput"
      hidden
      multiple
      @input="handleMediaSelected"
    />

    <Button
      class="flex-1 md:flex-none"
      variant="primary"
      :size="maxSmall ? 'xl' : 'lg'"
      :loading="isLoading"
      :disabled="!canSubmit"
      @click="$emit('handleSubmit')"
    >
      {{ $t("components.buttons.create_task") }}
    </Button>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { FileInput } from "@/Components/Inputs";

const { maxSmall } = useBreakpoints();
const emit = defineEmits(["uploadMedia"]);
const mediaInput = ref(null);

defineProps({
  isLoading: { type: Boolean, default: false },
  canSubmit: { type: Boolean, default: false },
});

const handleMediaSelected = (files) => {
  const result = [];

  files.forEach((file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      result.push({ file, src: e.target.result });

      if (result.length === files.length) {
        emit("uploadMedia", result);
      }
    };

    reader.readAsDataURL(file);
  });
};
</script>
